<template>
    <a-card :bordered="false">
        <div class="table-page-search-wrapper">
            <a-form layout="inline" @submit="handleSearch" :autoFormCreate="(form) => {
                    this.searchForm = form;
                }
                ">
                <a-row :gutter="48">
                    <a-col :md="12" :sm="24">
                        <a-form-item label="查询日期" fieldDecoratorId="date_time">
                            <a-range-picker :show-time="{ format: 'HH:mm' }" format="YYYY-MM-DD HH:mm"
                                :placeholder="['开始时间', '结束时间']" style="width:100%" />
                        </a-form-item>
                    </a-col>
                    <a-col :md="6" :sm="24">
                        <a-form-item label="手机号" fieldDecoratorId="contact_tel">
                            <a-input placeholder="手机号" />
                        </a-form-item>
                    </a-col>
                    <a-col :md="6" :sm="24">
                        <a-form-item label="订单号" fieldDecoratorId="order_no">
                            <a-input placeholder="订单号" />
                        </a-form-item>
                    </a-col>
                    <a-col :md="6" :sm="24">
                        <a-form-item label="订单状态" fieldDecoratorId="order_status">
                            <a-select placeholder="请选择" allowClear show-search option-filter-prop="children">
                                <a-select-option v-for="item in orderStatus" :key="item.id">{{
                                    item.name
                                }}</a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :md="6" :sm="24">
                        <a-form-item label="供应商" fieldDecoratorId="supplier_id">
                            <a-select placeholder="请选择" allowClear show-search option-filter-prop="children">
                                <a-select-option v-for="item in suppliers" :key="item.id">{{
                                    item.name
                                }}</a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :md="6" :sm="24">
                        <a-form-item label="分类" fieldDecoratorId="goods_category_id">
                            <a-select placeholder="请选择" allowClear show-search option-filter-prop="children">
                                <a-select-option v-for="item in categories" :key="item.id">{{
                                    item.name
                                }}</a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :md="6" :sm="24">
                        <span class="table-page-search-submitButtons">
                            <a-button type="primary" htmlType="submit">查询</a-button>
                        </span>
                    </a-col>
                </a-row>
            </a-form>
        </div>
        <div style="padding-bottom:24px;text-align: right;">
            <a-button type="primary" @click="handleExport" style="margin-right:12px">导出订单</a-button>
            <a-button type="primary" @click="handleLockOrderBatch" style="margin-right:12px">一键处理</a-button>
            <a-button @click="$refs.file.click()">
                <a-icon type="upload" />批量发货
            </a-button>
            <input type="file" ref="file" style="display: none" @change="upload" name="file" />
        </div>
        <s-table ref="table" size="default" :columns="columns" :data="loadData">
            <template slot="uid" slot-scope="text, record">
                1{{ (text + "").padStart(7, "0") }}
            </template>
            <template slot="cash_amount" slot-scope="text">
                {{text/100}}
            </template>
            <template slot="order_status2" slot-scope="text,record">
                {{record.deduction_quantity > 0 ? (record.score == 0 ? "现金":"积分+现金"):"积分"}}
            </template>
            <template slot="order_status" slot-scope="text, record">
                <span v-if="text === 0">待发货</span>
                <span v-else-if="text === 1">处理中</span>
                <span v-else-if="text === 2">已发货</span>
                <span v-else-if="text === 3">已取消</span>
            </template>
            <template slot="address" slot-scope="text, record">
                <div>
                    <span>{{ record.contact_name }}</span>
                </div>
                <div>
                    <span>{{ record.contact_tel }}</span>
                </div>
                <div>
                    <span>{{ record.address }}</span>
                </div>
            </template>
            <template slot="action" slot-scope="text, record">
                <a @click="handleLockOrder(record)">
                    处理
                </a>
                <a-divider type="vertical" />
                <a @click="handleCancelOrder(record)">
                    取消订单
                </a>
                <a-divider type="vertical" />
                <a @click="handleSendOrder(record)">
                    发货
                </a>
            </template>
        </s-table>
        <a-modal :visible="modal.visible" :title="'发货'" :ok-text="'确定'" :cancel-text="'取消'" @ok="handleOk"
            @cancel="modal.visible = false">
            <a-row>
                <a-col :span="4" style="line-height:32px">
                    快递信息：
                </a-col>
                <a-col :span="18">
                    <a-input v-model="modal.express_no" placeholder="请输入快递信息" />
                </a-col>
            </a-row>

        </a-modal>
    </a-card>
</template>

<script>
import STable from "@/components/table/";
import { gettMallOrder, updateMallOrderStatus, cancelMallOrder, deliverMallOrder, batchUpdateMallOrderStatus } from "@/api/mall";
import { ACCESS_TOKEN } from "@/store/mutation-types";
import { encodeJsonToQuery } from "@/utils/util";
import { getSupplierList } from "@/api/supplier";
import { getCategoryList } from '@/api/category'


export default {
    name: "mallOrder",
    components: {
        STable
    },
    data() {
        return {
            suppliers: [],
            categories: [],
            orderStatus: [
                { id: 0, name: '待发货' },
                { id: 1, name: '处理中' },
                { id: 2, name: '已发货' },
                { id: 3, name: '已取消' },
            ],
            columns: [
                {
                    title: "商品名称",
                    dataIndex: "name",
                    key: "name",
                },
                {
                    title: "用户uid",
                    dataIndex: "user_id",
                    key: "user_id",
                    scopedSlots: { customRender: "uid" }
                },
                {
                    title: "SKU",
                    dataIndex: "sku",
                    key: "sku",
                },
                {
                    title: "订单编号",
                    dataIndex: "order_no",
                    key: "order_no",
                },
                {
                    title: "下单时间",
                    dataIndex: "created",
                    key: "created",
                },
                {
                    title: "下单数量",
                    dataIndex: "num",
                    key: "num",
                },
                {
                    title: "兑换价",
                    dataIndex: "score",
                    key: "score",
                },
                {
                    title:"现金抵扣积分数量",
                    dataIndex:"deduction_quantity",
                    key:"deduction_quantity"
                },
                {
                    title:"现金支付金额(元)",
                    dataIndex:"cash_amount",
                    key:"cash_amount",
                    scopedSlots: { customRender: "cash_amount" }
                },
                {
                    title: "订单类型",
                    scopedSlots: { customRender: "order_status2" }
                },
                {
                    title: "供应商",
                    dataIndex: "supplier_name",
                    key: "supplier_name",
                },
                {
                    title:"分类",
                    dataIndex:"goods_category_name",
                    key:"goods_category_name"
                },
                {
                    title: "订单状态",
                    dataIndex: "order_status",
                    key: "order_status",
                    scopedSlots: { customRender: "order_status" }
                },
                {
                    title: "收货人信息",
                    dataIndex: "address",
                    key: "address",
                    scopedSlots: { customRender: "address" }
                },
                {
                    title: "物流信息",
                    dataIndex: "express_no",
                    key: "express_no"
                },
                {
                    title: "操作",
                    dataIndex: "action",
                    key: "action",
                    width: 200,
                    scopedSlots: { customRender: "action" }
                }
            ],
            loadData: (params) => {
                return gettMallOrder(Object.assign(params, this.queryParam)).then(
                    (res) => res
                );
            },
            modal: {
                visible: false,
                express_no: "",
                id: null,
            }
        };
    },
    methods: {
        handleSearch(e) {
            e.preventDefault();
            let dateTime = this.searchForm.getFieldValue("date_time")
            let orderStatus = this.searchForm.getFieldValue("order_status")
            this.queryParam = {
                order_no: this.searchForm.getFieldValue("order_no"),
                contact_tel: this.searchForm.getFieldValue("contact_tel"),
                supplier_id: this.searchForm.getFieldValue("supplier_id"),
                goods_category_id: this.searchForm.getFieldValue("goods_category_id"),
            };
            if (dateTime) {
                this.queryParam.start_date = dateTime[0] && dateTime[0].format('YYYY-MM-DD HH:mm:ss')
                this.queryParam.end_date = dateTime[1] && dateTime[1].format('YYYY-MM-DD HH:mm:ss')
            }
            if (orderStatus || orderStatus === 0) {
                this.queryParam.order_status = orderStatus
            }
            this.$refs.table.refresh();
        },
        handleExport() {
            let dateTime = this.searchForm.getFieldValue("date_time")
            let orderStatus = this.searchForm.getFieldValue("order_status")
            this.queryParam = {
                order_no: this.searchForm.getFieldValue("order_no"),
                contact_tel: this.searchForm.getFieldValue("contact_tel"),
                supplier_id: this.searchForm.getFieldValue("supplier_id"),
                goods_category_id: this.searchForm.getFieldValue("goods_category_id"),
            };
            if (dateTime) {
                this.queryParam.start_date = dateTime[0] && dateTime[0].format('YYYY-MM-DD HH:mm:ss')
                this.queryParam.end_date = dateTime[1] && dateTime[1].format('YYYY-MM-DD HH:mm:ss')
            }
            if (orderStatus || orderStatus === 0) {
                this.queryParam.order_status = orderStatus
            }
            const params = {
                token: this.$ls.get(ACCESS_TOKEN),
                ...this.queryParam
            };

            window.open("/api/admin/mall/orders/excel" + encodeJsonToQuery(params));
        },
        upload(e) {
            let files = e.target.files;
            if (files.length > 0) {
                let data = new FormData();
                data.append("file", files[0]);
                fetch("/api/admin/mall/order/delivery/excel", {
                    method: "POST",
                    body: data,
                    headers: {
                        Authorization: `Bearer ${this.$ls.get(ACCESS_TOKEN)}`,
                    },
                }).then((res) => {
                    if (res.status == 200) {
                        this.$refs.table.refresh();
                        const a = document.createElement("a");
                        let filename = res.headers
                            .get("content-disposition")
                            .replace("attachment; filename=", "");
                        res.blob().then((blob) => {
                            a.href = URL.createObjectURL(blob);
                            a.download = decodeURIComponent(filename);
                            a.click();
                            URL.revokeObjectURL(a.href);
                        });
                    } else if (res.status == 401) {
                        res.json().then((data) => {
                            //token过期或者token错误会进入此处，需要将登录状态清除并要求重新登录
                            this.$message.error(`上传失败，${data.msg}`);
                        });
                    }
                });
            }
        },
        //取消订单
        handleCancelOrder(record) {
            if (record.order_status === 3) {
                this.$message.error("订单为已取消状态");
                return;
            }
            if (record.order_status === 2) {
                this.$message.error("订单为已发货状态");
                return;
            }
            this.$confirm({
                title: "提示",
                content: "确定取消订单吗？",
                onOk: () => {
                    cancelMallOrder(record.id).then((res) => {
                        this.$message.success("取消成功");
                        this.$refs.table.refresh();
                    });
                },
                onCancel() {
                    console.log("Cancel");
                }
            });
        },
        //锁定订单
        handleLockOrder(record) {
            if (record.order_status === 0) {
                updateMallOrderStatus(record.id).then((res) => {
                    this.$message.success("处理成功");
                    this.$refs.table.refresh();
                });
            } else {
                this.$message.error("订单已处理");
            }
        },
        //批量锁定订单
        handleLockOrderBatch() {
            this.$confirm({
                title: "提示",
                content: "确定批量处理订单吗？",
                onOk: () => {
                    let dateTime = this.searchForm.getFieldValue("date_time")
                    this.queryParam = {
                        order_no: this.searchForm.getFieldValue("order_no"),
                        contact_tel: this.searchForm.getFieldValue("contact_tel"),
                        supplier_id: this.searchForm.getFieldValue("supplier_id"),
                        goods_category_id: this.searchForm.getFieldValue("goods_category_id"),
                    };
                    if (dateTime) {
                        this.queryParam.start_date = dateTime[0] && dateTime[0].format('YYYY-MM-DD HH:mm:ss')
                        this.queryParam.end_date = dateTime[1] && dateTime[1].format('YYYY-MM-DD HH:mm:ss')
                    }
                    batchUpdateMallOrderStatus(this.queryParam).then((res) => {
                        this.$message.success("批量处理成功");
                        this.$refs.table.refresh();
                    });
                },
                onCancel() {
                    console.log("Cancel");
                }
            });
        },
        //发货
        handleSendOrder(record) {
            if (record.order_status === 1 || record.order_status === 2) {
                this.modal.visible = true;
                this.modal.express_no = "";
                this.modal.id = record.id;
            } else {
                this.$message.error("订单状态不正确");
            }
        },
        handleOk() {
            if (!this.modal.express_no.trim()) {
                this.$message.error("请输入快递信息");
                return;
            }
            this.modal.visible = false;
            deliverMallOrder({
                id: this.modal.id,
                express_no: this.modal.express_no
            }).then((res) => {
                this.$message.success("发货成功");
                this.$refs.table.refresh();
                this.modal.visible = false;
            });
        },
        getCategoryList: function () {
            getCategoryList({ page_size: 10000 }).then(res => {
                this.categories = res.list
            })
        },
        getSupplierList() {
            getSupplierList().then(res => {
                this.suppliers = res.list
            })
        },
    },
    created() {
        this.getSupplierList()
        this.getCategoryList()
    }
};
</script>